// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2GClt","select":"Header_select__Znon5","clinic":"Header_clinic__3ED8-"};